<template>
  <div id="patientDownloads">
    <div id="weekTags" v-if="!isLoading">
      <span class="tag" @click="updateFilter('resources')" :class="{'active' : selectedFilter === 'resources'}" v-text="$t('message.labelResources')"></span>
      <span class="tag" @click="updateFilter('mealplans')" :class="{'active' : selectedFilter === 'mealplans'}" v-text="$t('message.labelMealPlans')"></span>
      <span class="tag" @click="updateFilter('seasonal')" :class="{'active' : selectedFilter === 'seasonal'}" v-text="$t('message.labelSeasonalDownloads')"></span>
      <span class="tag" v-for="item, index in lessons" :key="'week-list-' + index"
            :class="{'disabled' : item.status.locked, 'active' : selectedFilter === item.course_id }"
            v-text="item.week_name.replace('Week', $t('message.labelWeek'))" @click="updateFilter(item.course_id, item.status.locked)"></span>
    </div>
    <mu-row id="weekLists" v-if="!isLoading">
      <mu-col tablet="30" desktop="30">
        <mu-select-field :scroller="scroller" v-model="selectedFilter" v-on:change="updateFilter" hintText="Resources">
          <mu-menu-item :title="$t('message.labelResources')" value="resources"></mu-menu-item>
          <mu-menu-item :title="$t('message.labelMealPlans')" value="mealplans"></mu-menu-item>
          <mu-menu-item :title="$t('message.labelSeasonalDownloads')" value="seasonal"></mu-menu-item>
          <mu-menu-item v-for="item, index in lessons" :key="'week-list-' + index" :value="item.course_id"
                        :title="$t('message.labelDownloadsFrom') + ' ' + item.week_name.replace('Week', $t('message.labelWeek'))" :disabled="item.status.locked"></mu-menu-item>
        </mu-select-field>
      </mu-col>
      <mu-col tablet="30" desktop="30"></mu-col>
      <mu-col tablet="30" desktop="30"></mu-col>
    </mu-row>
    <div id="downloadTabs" v-if="!isLoading">
      <mu-row>
        <mu-col v-for="tab, tabIndex in tabs" :key="'download-tab-' + tabIndex" tablet="50" desktop="50" width="50">
          <a @click="setTab(tab.key)" class="tab" :class="{'active' : activeTab === tab.key }" v-text="tab.label"></a>
        </mu-col>
      </mu-row>
    </div>
    <mu-content-block v-if="isLoading || showFilterLoader" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div class="container" v-if="!isLoading || !showFilterLoader">
      <mu-row gutter v-if="activeTab === 'grid'">
        <mu-col class="download-item" width="100" tablet="50" desktop="33" v-for="res, index in items"
                :key="'download-item-' + index">
          <mu-card align="center" class="grid-item card-background-cover bottom" @click.native="saveTrackingCount(res)">
            <img v-once :src="res.image_url" width="100%"/>
            <mu-card-header v-once :title="res.title" :subTitle="res.description"></mu-card-header>
            <mu-card-actions class="actions">
              <mu-flat-button primary icon="file_download" :disabled="!$store.state.status.payment.paid" :label="res.button_text"></mu-flat-button>
            </mu-card-actions>
          </mu-card>
        </mu-col>
      </mu-row>
      <mu-card v-if="activeTab === 'list'" class="listViewSpacer">
        <mu-list>
          <div class="download-item" v-for="res, index in items" :key="'download-item-' + index">
            <mu-list-item disableRipple :title="res.title" :describeText="res.description"
                          @click.native="saveTrackingCount(res)">
              <mu-flat-button slot="right" primary icon="file_download" :disabled="!$store.state.status.payment.paid" :label="res.button_text"></mu-flat-button>
            </mu-list-item>
            <mu-divider v-if="items.length !== index + 1"/>
          </div>
        </mu-list>
      </mu-card>
    </div>
  </div>
</template>
<script>
  import ResourcesApi from '../../api/Resources'
  import LessonApi from '../../api/Lessons'
  import UserManager from '../../helpers/UserManager'
  import _ from "lodash";

  export default {
    name: 'patient-downloads',
    data() {
      return {
        isLoading: true,
        selectedFilter: "resources",
        user: {},
        items: [],
        activeTab: 'grid',
        showFilterLoader: false,
        tabs: [
          {
            label: this.$t('message.gridViewText'),
            key: 'grid',
          },
          {
            label: this.$t('message.listViewText'),
            key: 'list',
          },
        ]
      }
    },
    methods: {
      saveTrackingCount(res) {
        let self = this;
        if(self.$store.state.status.payment.paid === true) {
          if (self.selectedFilter === 'resources') {
            ResourcesApi.saveResourceCount({
              resource_id: res.resource_id
            });
          } else {
            LessonApi.saveDownloadCount({
              download_id: res.download_id
            });
          }
          window.open(res.link, '_blank');
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      },
      updateFilter(value, locked = null) {
        if (locked !== true) {
          let self = this;
          self.items = [];
          self.isLoading = false;
          self.showFilterLoader = true;

          self.selectedFilter = value;
          self.$nextTick(function () {

            if(value === 'seasonal') {
              self.loadSeasonal();
            }

            if (value === 'resources') {
              self.loadResources();
            } else {

              if (value === 'mealplans') {
                self.loadMealPlans();
              }
              else {
                self.loadDownloads(value);
              }
            }
          });
        }
      },
      setTab(tab) {
        let self = this;
        self.activeTab = tab;
      },
      loadSeasonal() {
        let self = this;
        ResourcesApi.getSeasonalDownloads().then(function (response) {
          self.items = response.data;
          self.isLoading = false;
          self.showFilterLoader = false;
        })
      },
      loadMealPlans() {
        let self = this;
        ResourcesApi.getMealPlans().then(function (response) {
          self.items = response.data;
          self.isLoading = false;
          self.showFilterLoader = false;
        })
      },
      loadResources() {
        let self = this;
        ResourcesApi.getResources().then((response) => {
          self.items = response.data;
          self.isLoading = false;
          self.showFilterLoader = false;
        });
      },
      loadDownloads(lesson_id) {
        let self = this;
        LessonApi.getDownloadsByCourseId(lesson_id).then((response) => {
          self.items = response.data;
          self.isLoading = false;
          self.showFilterLoader = false;
        });
      }
    },
    computed: {
      chunkedItems() {
        let self = this;
        return _.chunk(_.toArray(self.items), 3);
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/downloads');
      LessonApi.getLessonsList().then((response) => {
        // Filter lessons to deduplicate by week_name

        const uniqueWeekNames = new Set();
        self.lessons = response.data.filter(lesson => {
          if (!lesson.week_name) return false; // Skip if week_name is undefined/null
          if (uniqueWeekNames.has(lesson.week_name)) return false; // Skip duplicates
          uniqueWeekNames.add(lesson.week_name); // Add the new week_name
          return true; // Include this lesson
        });

        if (self.selectedFilter === 'resources') {
          self.loadResources();
        }
      });
    }
  }
</script>
<style>
  .listViewSpacer {
    margin-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// PatientDownloads.vue?21787588